module.exports = __webpack_public_path__ + "static/img/风险提示与人工复核.28acc780.png";